import React from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import ConfirmDialog from '../overlays/ConfirmDialog';

const mediaIcons = { image:'bi-image', video:'bi-play-circle', document:'bi-file-earmark' };
const mediaColors = { image:['#0891b2','#0e7490'], video:['#7c3aed','#6d28d9'], document:['#d97706','#b45309'] };

function ImageNode({ id, data, selected }) {
    const { setNodes, setEdges } = useReactFlow();
    const [showDelete, setShowDelete] = React.useState(false);
    const [imgError,   setImgError]   = React.useState(false);

    const mtype = data.mediatype || 'image';
    const [c1, c2] = mediaColors[mtype] || ['#0891b2','#0e7490'];
    const icon     = mediaIcons[mtype] || 'bi-image';

    const confirmDelete = () => {
        setShowDelete(false);
        setNodes(n => n.filter(x => x.id !== id));
        setEdges(e => e.filter(x => x.source !== id && x.target !== id));
    };

    return (
        <div style={{ width:200, background:'#fff', border:`2px solid ${selected ? c1 : '#e5e7eb'}`, borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', overflow:'hidden' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'7px 10px', background:`linear-gradient(to right, ${c1}, ${c2})` }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, color:'#fff', fontSize:11, fontWeight:700 }}>
                    <i className={`bi ${icon}`} style={{ fontSize:12 }}></i> Send {mtype.charAt(0).toUpperCase()+mtype.slice(1)}
                </div>
                <button onClick={e => { e.stopPropagation(); setShowDelete(true); }} style={btnStyle}>
                    <i className="bi bi-x" style={{ fontSize:12 }}></i>
                </button>
            </div>

            {/* Media preview */}
            {data.imageUrl && mtype === 'image' && !imgError ? (
                <div style={{ height:80, overflow:'hidden' }}>
                    <img src={data.imageUrl} alt="media" style={{ width:'100%', height:'100%', objectFit:'cover' }} onError={() => setImgError(true)}/>
                </div>
            ) : (
                <div style={{ height:64, display:'flex', alignItems:'center', justifyContent:'center', background:'#f8fafc' }}>
                    <i className={`bi ${icon}`} style={{ fontSize:24, color:'#d1d5db' }}></i>
                </div>
            )}

            <div style={{ padding:'6px 10px' }}>
                {data.mediaCaption ? (
                    <p style={{ fontSize:10, color:'#6b7280', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', margin:0 }}>{data.mediaCaption}</p>
                ) : (
                    <p style={{ fontSize:10, color:'#d1d5db', fontStyle:'italic', margin:0 }}>No caption</p>
                )}
            </div>

            <Handle id="a" type="target" position={Position.Left} style={hs(c1)}/>
            <Handle id="b" type="source" position={Position.Right} style={hs(c1)}/>
            {showDelete && <ConfirmDialog message="Delete this node?" onConfirm={confirmDelete} onCancel={() => setShowDelete(false)}/>}
        </div>
    );
}

const btnStyle = { background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.8)', padding:2, display:'flex', alignItems:'center' };
const hs = (color) => ({ width:10, height:10, background:color, border:'2px solid #fff', borderRadius:'50%' });

export default ImageNode;
